export default {
  'Home Page': 'Startseite',
  'How to use it': 'Wie man es benutzt',
}